// Tiny storefront helpers. No dependencies beyond what CRA already ships.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function photoUrl(src) {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
  return src;
}

export function peso(c) {
  const w = Math.floor((c || 0) / 100);
  return `\u20b1${w.toLocaleString()}.${String(Math.abs(c || 0) % 100).padStart(2, "0")}`;
}

// Readable text colour for a given background hex.
export function accentText(hex) {
  if (!hex) return "#ffffff";
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((x) => x + x).join("");
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? "#111111" : "#ffffff";
}

// Sample the dominant, saturated colour from the shop's logo (client-side canvas).
export function sampleLogoColour(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      try {
        const n = 40;
        const cv = document.createElement("canvas");
        cv.width = n; cv.height = n;
        const ctx = cv.getContext("2d");
        ctx.drawImage(img, 0, 0, n, n);
        const data = ctx.getImageData(0, 0, n, n).data;
        let rr = 0, gg = 0, bb = 0, count = 0;
        for (let i = 0; i < data.length; i += 4) {
          const r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
          if (a < 128) continue;
          const mx = Math.max(r, g, b), mn = Math.min(r, g, b);
          if (mx > 240 && mn > 240) continue; // skip near-white
          if (mx < 20) continue; // skip near-black
          const sat = mx === 0 ? 0 : (mx - mn) / mx;
          const w = 1 + sat * 3; // favour colourful pixels
          rr += r * w; gg += g * w; bb += b * w; count += w;
        }
        if (!count) return reject(new Error("no colour"));
        const to = (x) => Math.round(x / count).toString(16).padStart(2, "0");
        resolve(`#${to(rr)}${to(gg)}${to(bb)}`);
      } catch (e) { reject(e); }
    };
    img.onerror = () => reject(new Error("load failed"));
    img.src = url;
  });
}

export const TEMPLATES = [
  { key: "counter", name: "Counter", blurb: "Big photos in two columns. Best for food." },
  { key: "rack", name: "Rack", blurb: "A denser four-column grid with sizes and colours. Best for goods." },
  { key: "single", name: "Single", blurb: "One hero product with the story beneath. For a shop selling one thing." },
];

export const THEMES = [
  { key: "clean", name: "Clean", dot: "#16161A" },
  { key: "warm", name: "Warm", dot: "#C0552F" },
  { key: "night", name: "Night", dot: "#0B0C0E" },
  { key: "fresh", name: "Fresh", dot: "#0AA7C2" },
];
